import {HttpErrorResponse} from '@angular/common/http';
import {createAction, props} from '@ngrx/store';
import {ContentLibraryStoreFeatureKey} from './content-library-store.config';
import {ContentLibrary, Daum} from './content-library-store.dto';
import {IAddContentLibraryForm, IEditContentLibraryForm} from './content-library-store.facade';


export const scope = `[${ContentLibraryStoreFeatureKey}]`;

export const fetchContentLibrary = createAction(`${scope} Fetch Content Library`);
export const fetchContentLibrarySuccess = createAction(`${scope} Fetch Content Library Success`, (contentLiraries: ContentLibrary) => ({contentLiraries}));
export const fetchAllContentLibrary = createAction(`${scope} Fetch All Content Library`, (page:string) => ({page}));
export const fetchAllContentLibrarySuccess = createAction(`${scope} Fetch All Content Library Success`, (contentLiraries: Daum[]) => ({contentLiraries}));
export const fetchContentLibraryFailure = createAction(`${scope} Fetch Content Library Failure`, (error: HttpErrorResponse) => ({error}));

export const addContentLibrary = createAction(`${scope} ADD Content Library`, props<{formData: IAddContentLibraryForm}>());
export const addContentLibrarySuccess = createAction(`${scope} ADD Content Library Success`, (response: Daum) => ({response}));
export const addContentLibraryFailure = createAction(`${scope} ADD Content Library Failure`, (error: HttpErrorResponse) => ({error}));

export const changePage = createAction(`${scope} Change Page`, (pageNumber: number) => ({pageNumber}));
export const searchChange = createAction(`${scope} Search value changed`, (searchValue: string) => ({searchValue}));

export const updateContentLibrary = createAction(`${scope} UPDATE Content Library`, props<{formData: IEditContentLibraryForm}>());
export const updateContentLibrarySuccess = createAction(`${scope} UPDATE Content Library Success`, (response: Daum) => ({response}));
export const updateContentLibraryFailure = createAction(`${scope} UPDATE Content Library Failure`, (error: HttpErrorResponse) => ({error}));

export const deleteContent = createAction(`${scope} Delete Content`, (id: number) => ({id}));
export const deleteContentLibrarySuccess = createAction(`${scope} Delete Content Library Success`,(id: number) => ({id}));
export const deleteContentLibraryFailure = createAction(`${scope} Delete Content Library Failure`, (error: HttpErrorResponse) => ({error}));

export const clearState = createAction(`${scope} Clear State`);

